/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'styles/application.scss';

// eslint-disable-next-line no-unused-vars
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'trix';
import '@rails/actiontext';
// polyfills
import 'lazysizes/plugins/respimg/ls.respimg';

import { library, config, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faCity,
  faCaretRight,
  faCaretLeft,
  faCaretDown,
  faCaretUp,
  faDownload,
  faUser,
  faPencilAlt,
  faCircle,
  faUsers,
  faTrophy,
  faQuestion,
  faFighterJet,
  faGraduationCap,
  faHome,
  faCube,
  faEnvelope,
  faPhoneAlt,
  faChevronDoubleDown,
  faSearch,
  faStreetView,
  faAngleDoubleRight,
  faThumbsUp,
  faUserCheck,
  faHandHoldingUsd,
  faBullhorn,
  faUserCircle,
  faSortAmountUpAlt,
  faList,
  faFilter as fasFilter,
  faLockAlt as fasfaLockAlt,
  faStar as fasFaStar,
  faHeart as fasFaHeart,
  faMapMarkerAlt as fasMapMarkerAlt,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faAngleRight,
  faAngleLeft,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faMoneyBillAlt,
  faCheck,
  faSave,
  faTimesCircle,
  faPlus,
  faShoppingCart,
  faTrain,
  faTruck,
  faBuilding,
  faChartBar,
  faTimes,
  faCheckDouble,
  faCheckSquare,
  faLockAlt,
  faAlignJustify,
  faMapMarkerAlt,
  faCheckCircle,
  faEdit,
  faAngleDown,
  faAngleUp,
  faTrashAlt,
  faPaperPlane,
  faSpinner,
  faDollarSign,
  faExclamationTriangle,
  faFilter,
  faExternalLink,
  faInfoCircle,
  faQuestionCircle,
  faStar as farFaStar,
  faHeart as farFaHeart,
  faEnvelope as farEnvelope,
  faSearch as farSearch,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faTwitter,
  faFacebook,
  faFacebookF,
  faLinkedin,
  faInstagram,
  faYoutube,
  faPinterest,
  faRedditAlien,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';

import ComponentRegister from '../utils/ComponentRegister';
import helpfulDownloadsGA from '../utils/helpfulDownloadsGA';
import HomeHeader from '../bundles/HomeHeader';
import Disclosure from '../bundles/Disclosure';
import FAQsComponent from '../bundles/FAQsComponent';
import AlertBanner from '../bundles/AlertBanner';
import MuiPagination from '../bundles/MuiPagination';
import MuiTextInput from '../bundles/MuiTextInput';
import MuiViewablePassword from '../bundles/MuiViewablePassword';

config.autoAddCss = false;

library.add(
  faCity,
  faCaretRight,
  faCaretDown,
  faDownload,
  faAngleRight,
  faAngleLeft,
  faCaretLeft,
  faChevronDoubleDown,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faTwitter,
  faFacebook,
  faFacebookF,
  faLinkedin,
  faInstagram,
  faYoutube,
  faPinterest,
  faRedditAlien,
  faUser,
  faMoneyBillAlt,
  faPencilAlt,
  farFaHeart,
  fasFaHeart,
  farEnvelope,
  faCircle,
  faCheck,
  faUsers,
  faTrophy,
  faSave,
  faTimesCircle,
  faPlus,
  faQuestion,
  faFighterJet,
  faGraduationCap,
  faShoppingCart,
  faTrain,
  faTruck,
  faHome,
  faBuilding,
  faCube,
  faChartBar,
  faTimes,
  faCheckDouble,
  faCheckSquare,
  faLockAlt,
  fasfaLockAlt,
  faAlignJustify,
  faMapMarkerAlt,
  faCheckCircle,
  faEdit,
  faAngleDown,
  faAngleUp,
  faTrashAlt,
  faCaretUp,
  faPaperPlane,
  faDollarSign,
  faSpinner,
  fasFaStar,
  farFaStar,
  faExclamationTriangle,
  faFilter,
  faGoogle,
  faExternalLink,
  faInfoCircle,
  faEnvelope,
  faPhoneAlt,
  fasFilter,
  faSearch,
  farSearch,
  faStreetView,
  fasMapMarkerAlt,
  faAngleDoubleRight,
  faThumbsUp,
  faUserCheck,
  faHandHoldingUsd,
  faQuestionCircle,
  faUserCircle,
  faBullhorn,
  faSortAmountUpAlt,
  faList
);

const images = require.context('../images', true);
// eslint-disable-next-line no-unused-vars
const imagePath = (name) => images(name, true);

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit');
}

ComponentRegister.setup({
  HomeHeader,
  Disclosure,
  FAQsComponent,
  helpfulDownloadsGA,
  AlertBanner,
  MuiPagination,
  MuiTextInput,
  MuiViewablePassword,
});

dom.watch();

window.addEventListener('load', () => {
  helpfulDownloadsGA();
});
